// extracted by css-extract-rspack-plugin
module.exports =  {"wrapper":"a2ae1a55b3","root":"b266d6052c","link":"d43f31956b"};